// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "9c41253fb4bec62160b0c69815b15ead" + ".js";
};